class AiSubectData {

    constructor(id, mainSubjectText, sonSubjectList = []) {
        this.id = id;
        this.subjectText = mainSubjectText;
        this.sonSubjectList = sonSubjectList;
    }

    getSubjectText() {
        return this.subjectText;
    }

    addSubject(data) {
        this.sonSubjectList.push(data);
    }

    getSubjectTextList() {
        return this.sonSubjectList;
    }

    getId() {
        return this.id;
    }
}
export default AiSubectData